import AntdTable from 'components/AntdTable';
import { useMemo } from 'react';
import useModalConfirm from 'hook/useModalConfirm';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import { EDIT_PATH, MANAGE_TRACKING_CODE_PATH } from 'constant/appPath';
import { Table, Tooltip } from 'antd';
import { TooltipHide } from 'page/Application/ManageCompanyList/CompanyList/styled';
import { ButtonAction, GroupButtonAction } from 'style/styleComponent/styled';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const TableData = ({
  setCurrent,
  dataRaw,
  isLoading,
  emptyText,
  handleDeleteTrackingCode,
  isDisable,
  setIsDisable,
  onChange,
  listIdSelected,
  setListIdSelected,
  setSelectAllData,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const navigate = useNavigate();
  const { handleConfirmAction, contextHolder } = useModalConfirm();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();

  const dataSource = useMemo(() => {
    if (isLoading && !dataRaw) return [];
    if (dataRaw?.pages !== 0 && dataRaw?.pageNum - dataRaw?.pages === 1)
      return setCurrent(dataRaw?.pages);
    return dataRaw?.list.map((item) => ({
      ...item,
      key: item.trackingCodeId,
    }));
  }, [dataRaw, isLoading, setCurrent]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const columns = useMemo(() => {
    const handleEdit = (id) => {
      if (isOnline) {
        navigate(`/${MANAGE_TRACKING_CODE_PATH}/${EDIT_PATH}/${id}`);
      } else {
        errorNetWork();
      }
    };

    return [
      Table.SELECTION_COLUMN,
      {
        title: (
          <TooltipHide>
            <Tooltip title={'No.'} placement={'topLeft'}>
              No.
            </Tooltip>{' '}
          </TooltipHide>
        ),
        align: 'left',
        ellipsis: true,
        showSorterTooltip: false,
        render: (_, __, index) => (
          <TooltipHide>
            <Tooltip title={index + 1} placement={'topLeft'}>
              {index + 1}
            </Tooltip>
          </TooltipHide>
        ),
        width: 300,
      },
      {
        key: 'title',
        title: (
          <TooltipHide>
            <Tooltip title={'タイトル'} placement={'topLeft'}>
              タイトル
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'title',
        align: 'left',
        ellipsis: true,
        showSorterTooltip: false,
        render: (title) => (
          <TooltipHide>
            <Tooltip title={title} placement={'topLeft'}>
              {title}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'trackingCodeId',
        title: <TooltipHide style={{ paddingLeft: 22 }}>操作</TooltipHide>,
        dataIndex: 'trackingCodeId',
        render: (trackingCodeId, record) => (
          <GroupButtonAction>
            <ButtonAction
              type="link"
              onClick={() => handleEdit(trackingCodeId)}
            >
              <EditOutlined />
            </ButtonAction>
            <ButtonAction
              type="link"
              disabled={isDisable}
              onClick={() => {
                if (isOnline) {
                  handleConfirmAction({
                    confirmFn: handleDeleteTrackingCode,
                    title: `${record?.title}を削除してもよろしいでしょうか？`,
                    params: trackingCodeId,
                    okText: <span> 削除</span>,
                    setIsDisable: setIsDisable,
                  });
                  setIsDisable(true);
                } else {
                  errorNetWork();
                }
              }}
            >
              <DeleteOutlined />
            </ButtonAction>
          </GroupButtonAction>
        ),
        align: 'left',
        width: 120,
      },
    ];
  }, [
    isOnline,
    navigate,
    errorNetWork,
    isDisable,
    handleConfirmAction,
    handleDeleteTrackingCode,
    setIsDisable,
  ]);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,

    onSelect: (record, selected, selectedRows) => {
      if (selected) {
        setSelectAllData(false);
        setListIdSelected((keys) => [...keys, record.key]);
      } else {
        setSelectAllData(false);
        setListIdSelected((keys) => {
          const index = keys.indexOf(record.key);
          return [...keys.slice(0, index), ...keys.slice(index + 1)];
        });
      }
    },

    onSelectAll: (selected, selectedRows, changeRows) => {
      if (selected) {
        let listIdSelected = changeRows?.map((item) => item?.trackingCodeId);
        setListIdSelected((current) => [...current, ...listIdSelected]);
      } else {
        setSelectAllData(false);
        let listIdRemove = changeRows?.map((item) => item?.trackingCodeId);
        const newData = listIdSelected?.filter(
          (item) => !listIdRemove.includes(item),
        );
        setListIdSelected(newData);
      }
    },
    preserveSelectedRowKeys: true,
  };

  return (
    <>
      {contextHolder}
      {contextErrorNetWork}
      <AntdTable
        height={532}
        columns={columns}
        rowSelection={rowSelection}
        isLoading={isLoading}
        emptyText={emptyText}
        dataSource={dataSource}
        onChange={onChange}
      />
    </>
  );
};

export default TableData;
